import { BadgeCheckIcon, ChipIcon } from "@heroicons/react/solid";
import React from 'react';
import { skills } from "../data";

function Skills() {
    return (
        <section id="skills" className="text-gray-400 body-font">
            <div className="container px-5 py-24 mx-auto">
                <div className="text-center mb-20">
                    <ChipIcon className="w-10 h-10 text-white inline-block mb-4" />
                    <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
                        Skills &amp; Technologies
                    </h1>
                    <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
                        Here are some of the technologies I work with to build amazing projects.
                    </p>
                </div>
                <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
                    {skills.map((skill) => (
                        <div key={skill} className="p-2 sm:w-1/2 w-full">
                            <div className="bg-gray-800 rounded flex p-4 h-full items-center hover:bg-gray-700 transition-colors duration-300">
                                <BadgeCheckIcon className="text-green-400 w-6 h-6 flex-shrink-0 mr-4" />
                                <span className="title-font font-medium text-white">
                                    {skill}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Skills



// WEBPACK FOOTER //
// ./src/components/Skills.js